<template>
  <div class="pageContent mobileRecharge">
    <LoadingModal bgcolor="transparent" />
    <div v-if="!$store.state.pageLoading">
      <Top :title="name" :message="tips" v-if="tips != ''" />
      <div class="pageBigRadius pageCarServeShadow phone">
        <div class="pageFlexBetween pageFontWeight phoneType">
          <p>{{ area }}</p>
        </div>
        <div class="phoneNum">
          <van-field
            class="phoneInput"
            v-model="params.account"
            type="number"
            @input="handleInput"
            @blur="blur"
            maxlength="13"
            placeholder="请输入手机号码"
          />
        </div>
      </div>
      <VTitle val="请选择面值" :showLine="false" />
      <TypeList
        :status="radio"
        :list="selList"
        :activeIndex="selItem"
        @selItem="handleSel"
        :isMember="isMember"
        :canSel="canSel"
        :vip_discount="vip_discount"
      />
      <VTitle val="支付方式" :showLine="false" />
      <PayWay
        ref="payway"
        :sellData="sellData"
        :tips="tips"
        :discount="discount"
        :isWechatPay="wechatpay"
        :type="2"
        :params="params"
        :isSend="isSend"
        :balance="balance"
        :couponsId="couponsId"
        :couponsName="couponsName"
        :isMember="isMember"
        :vip_discount="vip_discount"
        :discount_coupons="discount_coupons"
        :can_use_power="can_use_power"
        :coupon_list="coupon_list"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
      />
      <Tips :content="describe" v-if="describe != ''" />
    </div>
  </div>
</template>
<script>
import { getProductList ,getMobileServer} from "api/onLine";
import defaultdata from "server/data/mobileRecharge.json";
import Tips from "server/data/tips.json";
export default {
  props: {
    type: String,
    name: String,
    cid: Number,
    balance: Number,
    couponsId: String,
    couponsName: String,
    couponsDeduct: Number,
    isMember: Boolean,
    mouldId: String,
    couponsBalanceList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      appimg: require("assets/sy.png"),
      radio: 0,
      phone: "",
      oldPhone: null,
      area: "",
      // 数据列表
      selList: [],
      selItem: null,
      canSel: false, // 整个列表是否可选
      selListDefaultData: [],
      // 支付数据
      sellData: { sell_price: -1 },
      tips: "",
      describe: "",
      discount: 0,
      index: 0,
      wechatpay: false,
      params: { account: "" },
      sms: "",
      isSend: true,
      data: {},
      vip_discount: 0,
      discount_coupons: [],
      can_use_power: false,
      coupon_list: [],
    };
  },
  created() {
    this.$store.commit("setPageLoading", true);
    this.selListDefaultData = defaultdata;
    this.params.account = this.$getItem("userModel").userPhone;
    if(this.params.account!=""){
      this.params.account =
          this.params.account.substr(0, 3) +
          " " +
          this.params.account.substr(3, 4) +
          " " +
          this.params.account.substr(7);
    }
    this.tips = Tips.mobileBillRecharge;
  },
  mounted() {    
    this.getArea();
  },
  methods: {
    handleLaunchFn(e) {
      console.log(e);
    },
    handleErrorFn(e) {
      console.log("fail", e.detail);
    },
    blur() {},
    resetData() {
      this.selList = this.selListDefaultData.list;
      this.canSel = false;
      this.selItem = null;
      this.sellData = { sell_price: -1 };
    },
    loadData(ident) {
      getProductList(ident, this.mouldId).then((res) => {
        this.$clear();
        if (res.status == 200) {
          if (typeof res.data == "object") {
             this.selList=res.data;
             this.canSel=true;
          }
        } else {
          this.resetData();
          this.$error(res.message);
        }
        this.$nextTick(() => {
          this.$store.commit("setPageLoading", false);
          this.$clear();
        });
      });
    },
    getArea() {
      if (this.type === "mobileBillRecharge") {
        // 控制默认值的类型
        this.radio = 0;
      } else {
        this.radio = 1;
      }      
      let phone=this.params.account.toString().replace(/ /g, "");      
      getMobileServer(phone, this.radio).then((res) => {
        this.$clear();
        if (res.status == 200) {
          if (typeof res.data == "object") {
            let arry = res.data.name.split("|");
            this.area = arry[1] + arry[2];
            this.loadData(res.data.iden);
          }
        } else {         
          this.$error(res.message);
        }
        this.$nextTick(() => {
          this.$store.commit("setPageLoading", false);
          this.$clear();
        });
      });
    },
    handleInput(val) {
      if (this.params.account != "") {
        let str = this.params.account.toString().replace(/ /g, "");
        let len = str.length;
        switch (true) {
          case len > 11:
            str =
              str.substr(0, 3) +
              " " +
              str.substr(3, 4) +
              " " +
              str.substr(7, 4);
            this.params.account = str;
            break;
          case len > 7:
            str =
              str.substr(0, 3) + " " + str.substr(3, 4) + " " + str.substr(7);
            this.params.account = str;
            break;
          case len > 3:
            str = str.substr(0, 3) + " " + str.substr(3);
            this.params.account = str;
            break;
          default:
            this.params.account = str;
        }
      }
      // 阻止11位后继续触发
      val = val.replace(/\s+/g, "");
      if (val === this.oldPhone) {
        return false;
      }
      this.oldPhone = val;
      if (this.$regPhone(val)) {
        this.getArea();
      } else {
        this.canSel = false;
        this.sellData = { sell_price: -1 };
        this.selItem = null;
      }
    },
    handleSel(i, price) {
      this.selItem = i; 
      this.sellData = {
        ...this.selList[i],
        sell_price: Number(this.selList[i].productDenomination),
      };
      this.params.productNo = this.selList[i].productNo;
      this.params.mouldId = this.mouldId;
    },
  },
};
</script>

<style scoped lang="less">
.mobileRecharge {
  .launch-weapp {
    width: 100px;
    height: 20px;
  }
  .discount_coupons {
    background: inherit;
    color: #fff;
    .van-cell {
      padding: inherit;
      align-items: center;
      margin-bottom: 15px;
      box-shadow: #ccc 0 0 5px;
      background: red;
      color: #fff;
      border-radius: 10px;
      .van-cell__title {
        flex: inherit;
        border-right: 2px solid #cccccc82;
        padding: 10px;
      }
      .van-cell__value {
        // padding: 0px 10px;
        margin: 10px 0px 10px 10px;
        text-align: left;
        color: #fff;
      }
      .van-radio {
        margin-right: 10px;
        color: #fff;
        border-color: #fff;
        border-width: 2px;
      }
      /deep/ .van-icon {
        border: 2px solid #f7f8fa;
      }
      /deep/ .van-radio__icon--checked {
        .van-icon {
          background-color: inherit;
          border-color: inherit;
        }
      }
      .left_money {
        font-size: 30px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 5px;
      }
      .left_time {
        background: #fff;
        color: red;
        border-radius: 10px;
        display: flex;
        align-items: center;
        /* justify-content: center; */
        height: 20px;
        font-size: 12px;
        span {
          padding: 0px 5px;
        }
      }
      .right_name {
        font-size: 16px;
        font-weight: bold;
      }
      .right_time {
        font-size: 14px;
      }
    }
  }
  .phone {
    // margin-top: 30px;
    padding: 14px;
    box-sizing: border-box;
    background: #fff;
    .phoneType {
      font-size: 15px;
      span {
        color: var(--hidColor);
        font-weight: normal;
      }
    }
    .phoneNum,
    .phoneInput {
      font-weight: 900;
      font-size: 30px;
      color: var(--redColor);
    }
    .phoneInput {
      padding: 0;
      /deep/ .van-field__control {
        color: var(--redColor);
      }
    }
  }
}
</style>
